import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

const BaseBallMatchTracker = observer(({ item }) => {
  const { getTypeData, getTracker, nextBatters, gameStatus } = item;
  const {
    ball,
    currentBatter,
    currentPitcher,
    firstBaseOccupied,
    firstBaseOccupiedBatter,
    out,
    secondBaseOccupied,
    secondBaseOccupiedBatter,
    strike,
    thirdBaseOccupied,
    thirdBaseOccupiedBatter
  } = getTypeData;

  if (currentBatter === null || currentPitcher === null) {
    return null;
  }
  const finalMessage = useMemo(() => {
    if (gameStatus === 'FINAL') {
      return `종료`;
    } else if (gameStatus === 'CANCEL' || gameStatus === 'SUSPENDED') {
      return '취소';
    } else if (gameStatus === 'DELAY' || gameStatus === 'POSTPONED') {
      return '연기';
    } else if (gameStatus === 'PENDING' || gameStatus === 'CUT') {
      return '중단';
    } else if (gameStatus === 'PAUSE') {
      return '일시 중단';
    }
  }, [gameStatus]);

  if (getTracker.status === 'final') {
    return (
      <div className="baseball_tracker">
        <div className={'dimmer'}>
          <h2>{finalMessage}</h2>
        </div>
        <div className="ground" />
      </div>
    );
  } else {
    return (
      <div className="baseball_tracker">
        <div className="ground">
          <div className="base">
            <span className={`b1 ${firstBaseOccupied ? 'on' : ''}`} />
            <span className={`b2 ${secondBaseOccupied ? 'on' : ''}`} />
            <span className={`b3 ${thirdBaseOccupied ? 'on' : ''}`} />
          </div>
          <div className="count">
            <dl className="b">
              <dt>B</dt>
              <dd className={`n${ball}`}>
                <em></em>
                <em></em>
                <em></em>
              </dd>
            </dl>
            <dl className="s">
              <dt>S</dt>
              <dd className={`n${strike}`}>
                <em></em>
                <em></em>
                <em></em>
              </dd>
            </dl>
            <dl className="o">
              <dt>O</dt>
              <dd className={`n${out}`}>
                <em></em>
                <em></em>
                <em></em>
              </dd>
            </dl>
          </div>
          <div className="base_on">
            <span className="defence">
              <em>{currentPitcher.name}</em>
            </span>
            <span className="offence">
              <em>{currentBatter.name}</em>
            </span>
            <span className="base1">
              <em>{firstBaseOccupiedBatter && firstBaseOccupiedBatter.name}</em>
            </span>
            <span className="base2">
              <em>
                {secondBaseOccupiedBatter && secondBaseOccupiedBatter.name}
              </em>
            </span>
            <span className="base3">
              <em>{thirdBaseOccupiedBatter && thirdBaseOccupiedBatter.name}</em>
            </span>
          </div>
          <div className="player">
            {nextBatters.map((value, key) => {
              return (
                <span key={key}>
                  {value.stat.battingSlot} {value.name}
                </span>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
});

export default BaseBallMatchTracker;
